import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { toast, ToastContainer } from "react-toastify";
import { Button, Card, Col, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import { Link } from "react-router-dom";
import BreadCrumb from "../../Components/BreadCrumbComp";
import GetApiCall from "../../Api/GetApi";
import { useNavigate } from "react-router-dom";
import PostApiCall from "../../Api/Api";
import Notiflix from "notiflix";
import {
  Clock,
  Download,
  Edit,
  Eye,
  Mail,
  Minus,
  Phone,
  Plus,
} from "react-feather";
import defaultUser from "../../assets/profile/defaultuser.png";
import * as XLSX from "xlsx";
import { docStatus, userStatus } from "./helper";
import { genareteColor } from "../../Helper/GenerateStatusColor";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { delay } from "../../Helper/ToastDelay";
import CustomDataTable from "../../Components/CustomDataTable";
import moment from "moment";
import { PRIMARY_COLOR, PRIMARY_TEXT_COLOR } from "../../color";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_orange.css";
import CommonModal from "../../Components/CommonModal";
import DashboardSummary from "./DashboardSummary";
import StatusSummary from "./StatusSummary";
const AuditorListPage = () => {
  let history = useNavigate();



  const columns = [
    {
      field: "fld_employeeid",
      header: "Id",
      sortable: true,
      headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "100px", fontSize: "13px" },
    },
    {
      field: "fld_onboardstatus",
      header: "Onboarding Status",
      sortable: true,
      body: (rowData) => (
        <span
          className={`${genareteColor(
            rowData.fld_onboardstatus
          )} font-size-3 rounded-3 px-2`}
        >
          {rowData.fld_onboardstatus}
        </span>
      ),
      headerStyle: { minWidth: "180px", fontSize: "13px" },
      bodyStyle: { minWidth: "160px", fontSize: "13px" },
    },
    {
      field: "fld_verifydoc",
      header: "Document Status",
      sortable: true,
      body: (rowData) => {
        let verifyValue = rowData?.fld_verifydoc;
        let displayText = "Pending";

        if (verifyValue == "1") {
          displayText = "Submitted";
        } else if (verifyValue == "2") {
          displayText = "Approved";
        }

        return (
          <span
            className={`${genareteColor(
              displayText
            )} font-size-3 rounded-3 px-2`}
          >
            {displayText}
          </span>
        );
      },
      headerStyle: { width: "150px", minWidth: "180px", fontSize: "13px" },
      bodyStyle: { minWidth: "150px", fontSize: "13px" },
    },
    {
      header: "Action",
      body: (rowData) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span>
            <button
              className="btnsAudit"
              onClick={() =>
                window.open(
                  `/view-auditor/id=${encodeURIComponent(rowData?.fld_id[0])}`
                )
              }
              style={{ textTransform: "capitalize", fontSize: "11px" }}
            >
              <Eye size={15} /> View
            </button>
          </span>
          <span className="ml-2">
            <button
              onClick={() => {
                // sendMail(rowData.fld_email, rowData.fld_name, rowData.fld_id[0])
                setSelectedRow(rowData);
                setCallCount(Number(rowData?.fld_callcount) || 0);
                setModalOpen(true);
              }}
              className="btnsAudit"
              style={{ textTransform: "capitalize", fontSize: "10px" }}
            >
              <Clock size={15} /> Tracker
            </button>
          </span>
        </div>
      ),
      headerStyle: { width: "250px", minWidth: "250px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
    {
      field: "fld_name",
      header: "Name",
      sortable: true,
      body: (rowData) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            className="rounded-circle shadow-md mr-2 border"
            style={{
              width: "30px",
              height: "30px",
            }}
          >
            <img
              width={"100%"}
              height={"100%"}
              className="p-1 rounded-circle"
              src={process.env.REACT_APP_FILE_PATH_URL + rowData.fld_photo}
              onError={(e) => (e.target.src = defaultUser)}
            />
          </div>
          <span
            style={{
              maxWidth: "120px",
              textTransform: "capitalize",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={rowData.fld_name}
          >
            {rowData.fld_name}
          </span>
        </div>
      ),
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_email",
      header: "Email",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_mobile",
      header: "Contact",
      sortable: true,
      headerStyle: { width: "150px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { minWidth: "150px", fontSize: "13px" },
    },
    {
      field: "fld_presentcity",
      header: "City",
      sortable: true,
      headerStyle: { width: "150px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { minWidth: "150px", fontSize: "13px" },
    },
    {
      field: "fld_overall",
      header: "Rating",
      sortable: true,
      headerStyle: { width: "150px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { minWidth: "150px", fontSize: "13px" },
    },
    {
      field: "fld_verifyemp",
      header: "Verified",
      sortable: true,
      body: (rowData) => {
        let verifyValue = rowData?.fld_verifyemp;
        let displayText = "";

        if (verifyValue == "1") {
          displayText = "Auditor";
        } else if (verifyValue == "2") {
          displayText = "Employee";
        }

        return (
          <span className={` font-size-3 rounded-3 px-2`}>{displayText}</span>
        );
      },
      headerStyle: { width: "150px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { minWidth: "150px", fontSize: "13px" },
    },
    {
      field: "fld_onboardremark",
      header: "Remarks",
      sortable: true,
      headerStyle: { width: "150px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { maxWidth: "150px", fontSize: "13px" },
    },
  ];

  const [auditorData, setauditorData] = useState([]);
  const [filteredData, setFilteredData] = useState(auditorData);
  const [searchVal, setSearchVal] = useState("");
  const [cityOption, setCityOption] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [totalRecordCount, setTotalRecordCount] = useState(0);

  console.log("mritunjayfilterdata" + filteredData.length);


  const [selectedFilter, setSelectedFilter] = useState({
    value: "All",
    label: "All",
  });
  const [selectedCity, setSelectedCity] = useState({
    value: "All",
    label: "All",
  });
  const [selectedFilterStatus, setSelectedFilterStatus] = useState({
    value: "All",
    label: "All",
  });

  const [selectedUserType, setSelectedUserType] = useState({
    value: "All",
    label: "All",
  });

  const [selectedDay, setSelectedDay] = useState({
    value: "All",
    label: "All",
  });

  const [selectedShift, setSelectedShift] = useState({
    value: "All",
    label: "All",
  });

  const updateFilterUserType = (selectedOption) => {
    setSelectedUserType(selectedOption);
    filterData(searchVal, selectedFilter, selectedFilterStatus, selectedOption, selectedCity, selectedDay, selectedShift);
  };

  const updateFilterCity = (selectedOption) => {
    setSelectedCity(selectedOption);
    filterData(
      searchVal,
      selectedFilter,
      selectedFilterStatus,
      selectedUserType,
      selectedOption,
      selectedDay
    );
  };

  const updateFilterDay = (selectedOption) => {
    setSelectedDay(selectedOption);
    filterData(
      searchVal,
      selectedFilter,
      selectedFilterStatus,
      selectedUserType,
      selectedCity,
      selectedOption,
      selectedShift
    );
  };

  const updateFilterShift = (selectedOption) => {
    setSelectedShift(selectedOption);
    filterData(
      searchVal,
      selectedFilter,
      selectedFilterStatus,
      selectedUserType,
      selectedCity,
      selectedDay,
      selectedOption
    );
  };

  const updateSearchQuery = (value) => {
    setSearchVal(value);
    filterData(value, selectedFilter, selectedFilterStatus, selectedUserType, selectedCity, selectedDay, selectedShift);
  };

  const updateFilter = (selectedOption) => {
    console.log("selectedOption", selectedOption);
    setSelectedFilter(selectedOption);
    filterData(searchVal, selectedOption, selectedFilterStatus, selectedUserType, selectedCity, selectedDay, selectedShift);
  };

  const updateFilterStatus = (selectedOption) => {
    setSelectedFilterStatus(selectedOption);
    filterData(searchVal, selectedFilter, selectedOption, selectedUserType, selectedCity, selectedDay, selectedShift);
  };

  const filterData = (search, filter, status, userType, city, day, shift) => {
    const filtered = auditorData.filter((item) => {
      const searchMatches = Object.values(item).some((value) =>
        String(value).toLowerCase().includes(search.toLowerCase())
      );
      const statusMatches =
        !filter ||
        item.fld_onboardstatus === filter.value ||
        filter.value === "All";
      // item.fld_verifydoc == filter.value;
      const activeStatusMatches =
        !status ||
        item.fld_verifydoc == status.value ||
        (item.fld_verifydoc === null && status.value == "0") ||
        status.value === "All";
      const userTypeMatches =
        !userType ||
        item.fld_qualification === userType.value ||
        userType.value === "All";
      const cityMatches =
        !city || item.fld_presentcity === city.value || city.value === "All";
      const dayMatches =
        !day ||
        day.value === "All" ||
        (() => {
          try {
            const availability = JSON.parse(item.fld_availabilityremark || "[]");
            return availability.some((avail) => {
              const dayMatch = day.value === "All" || avail.day === day.value;
              const shiftMatch =
                !shift ||
                shift.value === "All" ||
                (shift.value === "Day" && avail.dayShift) ||
                (shift.value === "Night" && avail.nightShift);
              return dayMatch && shiftMatch;
            });
          } catch {
            return false;
          }
        })();

      return (
        searchMatches &&
        statusMatches &&
        activeStatusMatches &&
        userTypeMatches &&
        cityMatches &&
        dayMatches
      );
    });
    setFilteredData(filtered);
  };

  console.log("filterData" + filterData.length);

  const getAuditorList = async () => {
    Notiflix.Loading.standard();
    try {
      const res = await PostApiCall.postRequest(
        { id: "" },
        "Job_GetAuditorList"
      );
      const { data } = await res.json();
      Notiflix.Loading.remove();

      setauditorData(data);
      setFilteredData(data);
      setTotalRecordCount(data?.length)

      setRefresh(false)
      // const dd = data
      //   ?.map((ele) => ele.fld_presentcity) // Extract `fld_presentcity`
      //   .filter((ele) => ele !== null) // Remove null values
      //   .map((city) => ({ value: city, label: city })); // Map to `value` and `label`

      // setCityOption((prev) => [
      //   ...prev,
      //   { value: "All", label: "All" },
      //   ...dd,
      // ]);
      // Extract `fld_presentcity`, remove nulls, and ensure uniqueness
      const dd = Array.from(
        new Set(
          data
            ?.map((ele) => ele?.fld_presentcity) // Extract `fld_presentcity`
            .filter((ele) => ele !== null) // Remove null values
        )
      ).map((city) => ({ value: city, label: city })); // Map to `value` and `label`

      setCityOption((prev) => [...prev, { value: "All", label: "All" }, ...dd]);
    } catch (error) {
      console.error(error);
      Notiflix.Loading.remove();
    }
  };

  useEffect(() => {
    getAuditorList();
  }, [refresh]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const exportToExcel = (data, fileName) => {
    // Prepare the data for the worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Write and download the file
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  // const exportToExcel = (data, fileName) => {
  //   const worksheet = XLSX.utils.json_to_sheet(data);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  //   XLSX.writeFile(workbook, `${fileName}.xlsx`);
  // };

  const sendMail = async ({
    email,
    name,
    id,
    isMail,
    callCount,
    remindercount,
  }) => {
    Notiflix.Loading.standard();
    try {
      const dd = await PostApiCall.postRequest(
        {
          email: email,
          name: name,
          id: id,
          isMail,
          callcount: callCount,
          remindercount,
        },
        `JobAuditProfileReminder`
      );

      const res = await dd.json();
      if (dd.status === 200 || dd.status === 201) {
        toast.success(res.data, {
          autoClose: delay,
          toastId: 1,
        });
        setRefresh(true);
        Notiflix.Loading.remove();
      } else {
        throw new Error(res.data);
      }
    } catch (error) {
      toast.error(error.message || SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    }
    setModalOpen(false);
    setRefresh(true)
    Notiflix.Loading.remove();
  };

  const [callCount, setCallCount] = useState(0);

  const increaseCallCount = () => {
    setCallCount((prev) => prev + 1);
  };

  const decreaseCallCount = () => {
    setCallCount((prev) => Math.max(0, prev - 1));
  };

  return (
    <div className="App">
      <ToastContainer />
      <section className="section marginLeftRight">
        <div className="">
          <div className="w-100 mt-5">
            <BreadCrumb icon={false} subitem={"Auditor List"} />
          </div>
          <DashboardSummary alldata={auditorData} />
          <Card className="border-0 p-4 rdt_Wrapper mb-4 mt-4 shadow ">
            <Row>
              <Col
                sm="12"
                md="3"
                className="input-icon"
                style={{ borderRadius: 10, zIndex: 4 }}
              >
                <Label>Onboarding Status</Label>
                <Select
                  className="React w-100"
                  classNamePrefix="select"
                  placeholder="Filter"
                  name="color"
                  options={[{ value: "All", label: "All" }, ...userStatus]}
                  onChange={(selectedOption) => updateFilter(selectedOption)}
                  value={selectedFilter}
                />
              </Col>
              <Col
                sm="12"
                md="3"
                className="input-icon"
                style={{ borderRadius: 10, zIndex: 5 }}
              >
                <Label>Document Status</Label>
                <Select
                  className="React "
                  classNamePrefix="select "
                  name="color"
                  placeholder="Select"
                  options={docStatus}
                  onChange={(selectedOption) =>
                    updateFilterStatus(selectedOption)
                  }
                  value={selectedFilterStatus}
                />
              </Col>
              <Col
                sm="12"
                md="3"
                className="input-icon"
                style={{ borderRadius: 10, zIndex: 3 }}
              >
                <Label>Education</Label>
                <Select
                  className="React w-100"
                  classNamePrefix="select"
                  placeholder="Filter"
                  name="usertype"
                  options={[
                    { value: "All", label: "All" },
                    { value: "10th", label: "10th" },
                    { value: "12th", label: "12th" },
                    { value: "Diploma", label: "Diploma" },
                    { value: "Graduation", label: "Graduation" },
                    { value: "Post Graduation", label: "Post Graduation" },
                    {
                      value: "CA/CS/CMA Foundation",
                      label: "CA/CS/CMA Foundation",
                    },
                    { value: "CA/CS/CMA Inter", label: "CA/CS/CMA Inter" },
                    {
                      value: "CA/CS/CMA Finalist",
                      label: "CA/CS/CMA Finalist",
                    },
                    { value: "CA/CS/CMA", label: "CA/CS/CMA" },
                  ]}
                  onChange={(selectedOption) =>
                    updateFilterUserType(selectedOption)
                  }
                  value={selectedUserType}
                />
              </Col>
              <Col
                sm="12"
                md="3"
                className="input-icon"
                style={{ borderRadius: 10, zIndex: 2 }}
              >
                <Label>City</Label>
                <Select
                  className="React w-100"
                  classNamePrefix="select"
                  placeholder="Filter"
                  name="city"
                  options={cityOption}
                  onChange={(selectedOption) =>
                    updateFilterCity(selectedOption)
                  }
                  value={selectedCity}
                />
              </Col>
            </Row>
            <Row>
              <Col
                sm="12"
                md="3"
                className="input-icon"
                style={{ borderRadius: 10, zIndex: 1 }}
              >
                <Label>Available Day</Label>
                <Select
                  className="React w-100"
                  classNamePrefix="select"
                  placeholder="Filter"
                  name="day"
                  options={[
                    { value: "All", label: "All" },
                    { value: "Monday", label: "Monday" },
                    { value: "Tuesday", label: "Tuesday" },
                    { value: "Wednesday", label: "Wednesday" },
                    { value: "Thursday", label: "Thursday" },
                    { value: "Friday", label: "Friday" },
                    { value: "Saturday", label: "Saturday" },
                    { value: "Sunday", label: "Sunday" },
                  ]}
                  onChange={(selectedOption) => updateFilterDay(selectedOption)}
                  value={selectedDay}
                />
              </Col>
              <Col
                sm="12"
                md="3"
                className="input-icon"
                style={{ borderRadius: 10, zIndex: 1 }}
              >
                <Label>Available Shift</Label>
                <Select
                  className="React w-100"
                  classNamePrefix="select"
                  placeholder="Filter"
                  name="shift"
                  options={[
                    { value: "All", label: "All" },
                    { value: "Day", label: "Day" },
                    { value: "Night", label: "Night" },
                  ]}
                  onChange={(selectedOption) => updateFilterShift(selectedOption)}
                  value={selectedShift}
                />
              </Col>
            </Row>
          </Card>

          <Card className="border-0 p-4 rdt_Wrapper shadow ">
            <div className=" d-flex justify-content-between flex-wrap">
              <div className="d-flex flex-wrap align-items-center mb-3 ">
                <div style={{ flex: '1 1 auto', minWidth: '200px' }}>
                  <Input
                    className="shadow-sm w-100"
                    type="text"
                    placeholder="Search..."
                    onChange={(e) => updateSearchQuery(e.target.value)}
                    value={searchVal}
                  />
                </div>


              </div>


              <div className="mt-md-0 mt-2">
                {/* <div className="mt-md-0 mt-2 md-text-right"> */}
                <button
                  className="cancelBtn mr-2"
                  onClick={() => exportToExcel(filteredData, "AuditorList")}
                >
                  <Download size={15} /> Export
                </button>
                <button
                  className=" btns"
                  onClick={() => history("/add-auditor")}
                >
                  Add User
                </button>
                {/* </div> */}
              </div>
            </div>
            <div className=" d-flex mb-2 justify-content-between flex-wrap">
              <div style={{ flex: '0 0 auto', minWidth: '200px' }}>
                <StatusSummary filteredData={filteredData} totalRecordCount={totalRecordCount} />
              </div>
            </div>

            <CustomDataTable
              data={filteredData}
              columns={columns}
              onRowClick={(row) => {
                const id = encodeURIComponent(row?.fld_id[0]);
                window.open(`/view-auditor/id=${id}`, "_blank"); // Open in a new tab
              }}
              compact={true} // Enables compact styling
            />

            {/* <DataTable
              highlightOnHover
              className="dataTable-custom"
              data={filteredData}
              columns={columnDefs}
              fixedHeader
              pagination
              // paginationPerPage={10}
              paginationPerPage={rowsPerPage}
              onChangePage={(page) => setCurrentPage(page)} // Update the current page on pagination
              // onRowClicked={(row) => {
              //   history({ pathname: "/view-auditor", state: row });
              // }}
              onRowClicked={(row) => {
                const id = encodeURIComponent(row?.fld_id[0]);
                window.open(`/view-auditor/id=${id}`, "_blank"); // Open in a new tab
              }}
              customStyles={{
                head: {
                  style: {
                    background: "transparent", // Remove the default background color
                  },
                },
                headRow: {
                  style: {
                    backgroundColor: "white",
                    color: "#ca8636",

                    //   marginBottom: "10px",
                  },
                },
                headCells: {
                  style: {
                    // fontWeight: "bold",
                    fontSize: "14px",
                    textTransform: "capitalize",
                  },
                },
              }}
            /> */}
          </Card>
        </div>
      </section>
      {modalOpen === true && (
        <CommonModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          heading={"Mail & Call Reminders"}
          contentBody={
            <div className="">
              <div className="d-grid gap-4">
                {/* Mail Section */}
                <div className="d-grid gap-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-2">
                      <Mail size={16} className="h5 text-primary mr-2" />
                      <h6 className="" style={{ color: PRIMARY_TEXT_COLOR }}>
                        Mail Status
                      </h6>
                    </div>
                  </div>

                  <div className="row g-3">
                    <div className="col-6">
                      <div className="border rounded p-3">
                        <div
                          className="small "
                          style={{ color: PRIMARY_TEXT_COLOR }}
                        >
                          Total Mails
                        </div>
                        <div className="fs-4 fw-semibold">
                          {selectedRow?.fld_remindercount || 0}
                        </div>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="border rounded p-3">
                        <div
                          className="small "
                          style={{ color: PRIMARY_TEXT_COLOR }}
                        >
                          Last Mail
                        </div>
                        <div className="small fw-medium">
                          {selectedRow?.fld_remindertime !== "" ? moment(selectedRow?.fld_remindertime).format(
                            "LLL"
                          ) : "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    onClick={() =>
                      sendMail({
                        email: selectedRow?.fld_email,
                        name: selectedRow?.fld_name,
                        id: selectedRow?.fld_id[0],
                        isMail: true,
                        callCount: callCount,
                        remindercount: selectedRow?.fld_remindercount,
                      })
                    }
                    className=" cancelBtn w-100 my-3"
                    style={{ textTransform: "capitalize" }}
                  >
                    <Mail size={16} className="mr-2" />
                    Send Reminder Mail
                  </button>
                </div>

                {/* Call Section */}
                <div className="d-grid gap-3 mt-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-2">
                      <Phone size={16} className="h5 text-success mr-2" />
                      <h6 className="" style={{ color: PRIMARY_TEXT_COLOR }}>
                        Call Counter
                      </h6>
                    </div>
                  </div>

                  <div className="d-flex align-items-center justify-content-between border rounded p-3">
                    <button
                      className="btns btn-sm "
                      style={{ opacity: callCount === 0 ? 0.2 : 1 }}
                      onClick={decreaseCallCount}
                      disabled={callCount === 0}
                    >
                      <Minus size={16} />
                    </button>

                    <div
                      className="fs-4 fw-semibold"
                      style={{ color: PRIMARY_TEXT_COLOR }}
                    >
                      {callCount}
                    </div>

                    <button className="btns btn-sm" onClick={increaseCallCount}>
                      <Plus size={16} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
          onConfirm={() => {
            sendMail({
              email: selectedRow?.fld_email,
              name: selectedRow?.fld_name,
              id: selectedRow?.fld_id[0],
              isMail: false,
              callCount: callCount,
              remindercount: selectedRow?.fld_remindercount,
            });
          }}
          confirmText={"Submit"}
          cancelText={"Cancel"}
          onCancel={() => setModalOpen(false)}
        />
      )}
    </div>
  );
};

export default AuditorListPage;
